// @flow

import type { Merchant, PaymentPageCustomizationColors } from '../types';
import { getMerchantConfig } from '../get-merchant-config';

const validHexColor = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{4}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;

export function getPaymentPageColors(merchant: Merchant): PaymentPageCustomizationColors | null {
  const merchantConfig = getMerchantConfig(merchant);

  if (!merchantConfig || !merchantConfig.payment_page_customization) {
    return null;
  }

  const customization = merchantConfig.payment_page_customization;

  if (!customization.colors) {
    return null;
  }

  const { brand, background, highlight } = customization.colors;

  const validBrand = brand && validHexColor.test(brand) ? brand : undefined;
  const validBackground = background && validHexColor.test(background) ? background : undefined;
  const validHighlight = highlight && validHexColor.test(highlight) ? highlight : undefined;

  if (!validBrand && !validBackground && !validHighlight) {
    return null;
  }

  return {
    brand: validBrand,
    background: validBackground,
    highlight: validHighlight,
  };
}
